import React from 'react';
import moment from 'moment-timezone';

interface DateTimeColumnProps {
  dateTime: string;
}

export default React.memo((props: DateTimeColumnProps) => {
  return <>{props.dateTime ? moment(props.dateTime).format('hh:mm:ssa, MMMM - DD, YYYY') : '-'}</>;
});
